import PropTypes from 'prop-types';
import {
  OuterCard,
  Header,
  GrayBlock,
  GrayBlockContent,
  List,
  ListItem,
} from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Distributor/styled-components';
import useDistributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/useDistributor'
import DistributorWebsite from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Distributor/DistributorWebsite'

const DistributorCard = ({ typeKey, data, hidden = false }) => {
  const { t } = useDistributor();
  if (hidden) return null;
  return (
    <OuterCard>
      <Header>{t(typeKey)}</Header>
      <GrayBlock>
        <GrayBlockContent>
          <List>
            <ListItem>
              <b>{t('subscriptionForm:distributor.field_name')}:</b> {data.name}
            </ListItem>
            <ListItem>
              <b>{t('subscriptionForm:distributor.field_address')}:</b> {data.address}
            </ListItem>
            <ListItem>
              <b>{t('subscriptionForm:distributor.field_phone')}:</b> {data.phone}
            </ListItem>
            <ListItem>
              <DistributorWebsite website={data.website} t={t} />
            </ListItem>
          </List>
        </GrayBlockContent>
      </GrayBlock>
    </OuterCard>
  );
}

DistributorCard.propTypes = {
  typeKey: PropTypes.string.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string,
    phone: PropTypes.string,
    website: PropTypes.string,
  }).isRequired,
  hidden: PropTypes.bool,
};

export default DistributorCard;
